import React from 'react';
import './GradientBtn.css';

const GradientBtn = ({ children, className, onClick, type = "button", ...props }) => {
    return (
        <button className={`gradient-btn ${className || ''}`} onClick={onClick} type={type} {...props}>
            <span style={{ position: 'relative', zIndex: 2 }}>{children}</span>
            <svg className="gradient-border-svg">
                <rect
                    x="0.64" y="0.64"
                    style={{ width: "calc(100% - 1.28px)", height: "calc(100% - 1.28px)" }}
                    rx="29.36"
                    stroke="url(#gradBorder)"
                    strokeWidth="1.28"
                    fill="none"
                />
            </svg>
        </button>
    );
};

export default GradientBtn;
